import axios from 'axios'
import api from '@/api'

const CancelToken = axios.CancelToken
let cancelEbsSessionsGetTrainerActive
let cancelEbsSessionsGetTrainerComplete
let cancelEbsSessionsGetLearnerActive
let cancelEbsSessionsGetLearnerComplete

const data = {
  pagination: {},
  data: [],
  default: '',
  custom: {
    active: {
      pagination: {},
      data: []
    },
    complete: {
      pagination: {},
      data: []
    }
  }
}

const ebsSessions = {
  state: JSON.parse(JSON.stringify(data)),
  getters: {
    getEbsSessionsCustomActiveData: state => {
      return state.custom.active.data
    },
    getEbsSessionsCustomActivePagination: state => {
      return state.custom.active.pagination
    },
    getEbsSessionsCustomCompleteData: state => {
      return state.custom.complete.data
    },
    getEbsSessionsCustomCompletePagination: state => {
      return state.custom.complete.pagination
    }
  },
  mutations: {
    EBS_SESSIONS_ACTIVE_SET_DATA (state, payload) {
      state.custom.active.data = payload
    },
    EBS_SESSIONS_ACTIVE_SET_PAGINATION (state, payload) {
      state.custom.active.pagination = payload
    },
    EBS_SESSIONS_ACTIVE_CLEAR_DATA (state) {
      state.custom.active.data = JSON.parse(JSON.stringify(data.custom.active.data))
    },
    EBS_SESSIONS_ACTIVE_CLEAR_PAGINATION (state) {
      state.custom.active.pagination = JSON.parse(JSON.stringify(data.custom.active.pagination))
    },
    EBS_SESSIONS_COMPLETE_SET_DATA (state, payload) {
      state.custom.complete.data = payload
    },
    EBS_SESSIONS_COMPLETE_SET_PAGINATION (state, payload) {
      state.custom.complete.pagination = payload
    },
    EBS_SESSIONS_COMPLETE_CLEAR_DATA (state) {
      state.custom.complete.data = JSON.parse(JSON.stringify(data.custom.active.data))
    },
    EBS_SESSIONS_COMPLETE_CLEAR_PAGINATION (state) {
      state.custom.complete.pagination = JSON.parse(JSON.stringify(data.custom.active.pagination))
    }
  },
  actions: {
    ebsSessionsCancelRequests ({ commit }) {
      if (cancelEbsSessionsGetTrainerActive) cancelEbsSessionsGetTrainerActive()
      if (cancelEbsSessionsGetTrainerComplete) cancelEbsSessionsGetTrainerComplete()
      if (cancelEbsSessionsGetLearnerActive) cancelEbsSessionsGetLearnerActive()
      if (cancelEbsSessionsGetLearnerComplete) cancelEbsSessionsGetLearnerComplete()
    },
    ebsSessionsGetTrainerActive ({ commit, getters }, data) {
      let queryUrlParams = data ? data.queryUrlParams : ''
      if (!queryUrlParams.includes('sortBy=')) {
        queryUrlParams += '&sortBy=dateStart'
      }
      if (!queryUrlParams.includes('sortDirection=')) {
        queryUrlParams += '&sortDirection=asc'
      }
      const querySelect = '&filters[state]=upcoming,in_process,register_pending,assessment_pending,feedback_pending,cancelled'
      return new Promise((resolve, reject) => {
        commit('EBS_SESSIONS_ACTIVE_CLEAR_DATA')
        commit('EBS_SESSIONS_ACTIVE_CLEAR_PAGINATION')

        axios({
          cancelToken: new CancelToken(function executor (ex) {
            cancelEbsSessionsGetTrainerActive = ex
          }),
          method: 'get',
          url: `${api.classroom}/dashboard/trainer-session-states${queryUrlParams}${querySelect}`
        }).then(response => {
          commit('EBS_SESSIONS_ACTIVE_SET_DATA', response.data.data)
          commit('EBS_SESSIONS_ACTIVE_SET_PAGINATION', response.data.pagination)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsSessionsGetTrainerComplete ({ commit, getters }, data) {
      let queryUrlParams = data ? data.queryUrlParams : ''
      if (!queryUrlParams.includes('sortBy=')) {
        queryUrlParams += '&sortBy=dateStart'
      }
      if (!queryUrlParams.includes('sortDirection=')) {
        queryUrlParams += '&sortDirection=desc'
      }
      const querySelect = '&filters[state]=complete,cancelled_completed'
      return new Promise((resolve, reject) => {
        commit('EBS_SESSIONS_COMPLETE_CLEAR_DATA')
        commit('EBS_SESSIONS_COMPLETE_CLEAR_PAGINATION')

        axios({
          cancelToken: new CancelToken(function executor (ex) {
            cancelEbsSessionsGetTrainerComplete = ex
          }),
          method: 'get',
          url: `${api.classroom}/dashboard/trainer-session-states${queryUrlParams}${querySelect}`
        }).then(response => {
          commit('EBS_SESSIONS_COMPLETE_SET_DATA', response.data.data)
          commit('EBS_SESSIONS_COMPLETE_SET_PAGINATION', response.data.pagination)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsSessionsGetLearnerActive ({ commit, getters }, data) {
      let queryUrlParams = data ? data.queryUrlParams : ''
      if (!queryUrlParams.includes('sortBy=')) {
        queryUrlParams += '&sortBy=dateStart'
      }
      if (!queryUrlParams.includes('sortDirection=')) {
        queryUrlParams += '&sortDirection=asc'
      }
      const querySelect = '&bookingStatus=booked,pending_acceptation,accepted,in_progress'
      return new Promise((resolve, reject) => {
        commit('EBS_SESSIONS_ACTIVE_CLEAR_DATA')
        commit('EBS_SESSIONS_ACTIVE_CLEAR_PAGINATION')

        axios({
          cancelToken: new CancelToken(function executor (ex) {
            cancelEbsSessionsGetLearnerActive = ex
          }),
          method: 'get',
          url: `${api.classroom}/dashboard/learner-session-states${queryUrlParams}${querySelect}`
        }).then(response => {
          commit('EBS_SESSIONS_ACTIVE_SET_DATA', response.data.data)
          commit('EBS_SESSIONS_ACTIVE_SET_PAGINATION', response.data.pagination)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsSessionsGetLearnerComplete ({ commit, getters }, data) {
      let queryUrlParams = data ? data.queryUrlParams : ''
      if (!queryUrlParams.includes('sortBy=')) {
        queryUrlParams += '&sortBy=dateStart'
      }
      if (!queryUrlParams.includes('sortDirection=')) {
        queryUrlParams += '&sortDirection=desc'
      }
      const querySelect = '&bookingStatus=passed,completed'
      return new Promise((resolve, reject) => {
        commit('EBS_SESSIONS_COMPLETE_CLEAR_DATA')
        commit('EBS_SESSIONS_COMPLETE_CLEAR_PAGINATION')

        axios({
          cancelToken: new CancelToken(function executor (ex) {
            cancelEbsSessionsGetLearnerComplete = ex
          }),
          method: 'get',
          url: `${api.classroom}/dashboard/learner-session-states${queryUrlParams}${querySelect}`
        }).then(response => {
          commit('EBS_SESSIONS_COMPLETE_SET_DATA', response.data.data)
          commit('EBS_SESSIONS_COMPLETE_SET_PAGINATION', response.data.pagination)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default ebsSessions
